import { useTranslation } from "react-i18next";
import { Box, TextField, Button } from "@mui/material";

import { SendButtonIcon } from "../../../assets/icons/chat-page-icons";

const ChatInputField = ({
  onSendMessage,
  onKeyDown,
  scrollToBottomOfChatContainer,
  chatInputRef,
}: {
  onSendMessage: () => Promise<void>;
  onKeyDown: (event: React.KeyboardEvent) => Promise<void>;
  scrollToBottomOfChatContainer: () => void;
  chatInputRef: React.RefObject<HTMLInputElement>;
}) => {
  const { t, i18n } = useTranslation("chat");

  const handleSendMessage = async () => {
    await onSendMessage();
    scrollToBottomOfChatContainer();
  };

  const handleKeyDown = async (event: React.KeyboardEvent) => {
    await onKeyDown(event);
    if (event.key === "Enter" && !event.shiftKey) {
      scrollToBottomOfChatContainer();
    }
  };

  return (
    <Box sx={styles.container}>
      <TextField
        fullWidth
        multiline
        rows={4}
        sx={styles.input}
        placeholder={t("sendMessage")}
        onKeyDown={handleKeyDown}
        inputRef={chatInputRef}
      />
      <Button
        variant="primary-sm"
        sx={styles.sendButton}
        onClick={handleSendMessage}
        endIcon={<SendButtonIcon sx={styles.sendButtonIcon(i18n.language)} />}
      >
        {t("send")}
      </Button>
    </Box>
  );
};

export default ChatInputField;

const styles = {
  container: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    padding: "0 24px 12px",
    "& .MuiInputBase-root": {
      padding: "0 !important",
    },
  },
  input: {
    flex: 1,
    width: "100%",
    height: "100%",

    fontFamily: "Montserrat",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "150%",

    borderRadius: "12px",
    border: "1px solid var(--Gray-300, #D0D5DD)",
    background: "var(--Base-White, #FFF)",
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
    "& .MuiOutlinedInput-root": {
      padding: "0 16px !important",
      borderRadius: "12px !important",
      border: "none !important",
    },
    "& .MuiInputBase-input": { padding: "10px 0 !important", borderRadius: "12px !important" },
  },
  sendButton: {
    width: "fit-content",
    alignSelf: "flex-end",
  },
  sendButtonIcon: (language: "ar" | "en") => ({
    transform: language === "ar" ? "scaleX(-1)" : "scaleX(1)",
  }),
};
